import React from "react";

const RequiredField = (value?: string) => {
  if (!value?.trim()) {
    return (
      <div className="absolute" role="alert">
        This field is required!
      </div>
    );
  }
};

export default RequiredField;
